export default {
  nav: {
    home: 'Գլխավոր',
    about: 'Մեր մասին',
    menu: 'Մենյու',
    gallery: 'Պատկերասրահ',
    hours: 'Աշխ. ժամեր',
    contact: 'Կապ',
    order: 'Պատվիրել',
    book: 'Ամրագրել սեղան',
    cart: 'Ձեր պատվերը',
  },
  hero: {
    badge: 'Բաց ենք օրը 24 ժամ',
    title1: 'Զգացեք',
    highlight: 'Հնդկաստանի',
    title2: 'ոգին ցանկացած ժամի',
    subtitle:
      'Իսկական հնդկական խոհանոց՝ չաթից մինչև թանդուր, մատուցվում է գիշեր ու ցերեկ։ Վայելեք մեր ջերմ տանիքում կամ պատվիրեք առաքում մինչև ձեր դուռը՝ երբ որ ցանկություն ունենաք։',
    explore: 'Ծանոթանալ մենյուին',
    delivery: 'Պատվիրել առաքում',
    stat1v: '24/7',
    stat1l: 'Միշտ բաց',
    stat2v: '174+',
    stat2l: 'Ուտեստ',
    stat3v: '60 րոպե',
    stat3l: 'Առաքում',
  },
  about: {
    eyebrow: 'Մեհֆիլի մասին',
    title: '24/7 հնդկական խնջույք Երևան սրտում',
    p1: 'Ստեղծված Arman International LLC կողմից, Mehfil 24/7-ը հնդկական հյուրընկալության ոգին է բերում Ռուբինյանց փողոց։ «Մեհֆիլ» նշանակում է ջերմ հավաքույթ, և հենց դա է, ինչ մենք մատուցում ենք՝ առատ ուտեստներ, թանդուրի վրա խորոված քյաբաբներ, համով լի չաթ և լույսով լի տանիք։',
    p2: 'Լինի դա գիշերային պանիր թիկկա, առավոտյան մասալա թեյ, թե ընտանեկան խնջույք, որը ձգվում է մինչև գիշեր՝ մեր խոհանոցը երբեք չի քնում։ Յուրաքանչյուր ուտեստ պատրաստվում է իսկական համեմունքներով և մատուցվում տան ջերմությամբ։',
    f1: 'Իսկական թանդուր խոհանոց',
    f2: 'Իսկական հնդկական համեմունքներ',
    f3: 'Արագ 24/7 առաքում',
    f4: 'Ջերմ տանիքի նստատեղեր',
    cta: 'Այցելեք մեզ այսօր',
    badgeV: 'Ինդեր',
    badgeL: 'Սեփականատեր և Հիմնադիր',
    owner: 'Ծանոթացեք Ինդերին՝ Mehfil 24/7-ի սրտի և հոգու հետևում կանգնած մարդուն։ Հնդկաստանից ժամանելով՝ նա իր ավանդական հնդկական համերի հանդեպ կիրքը բերեց Երևան, ստեղծելով ջերմ մի վայր, որտեղ յուրաքանչյուր հյուր իրեն տանն է զգում։ Նրա անմիջական մոտեցումը երաշխավորում է, որ յուրաքանչյուր ուտեստ կրում է հնդկական հյուրընկալության իսկական ջերմությունը։',
  },
  menu: {
    eyebrow: 'Մեր մենյուն',
    title: '174 ուտեստ ցանկացած ժամի համար',
    subtitle:
      'Փողոցային չաթից և ծխագույն թանդուր ստարտերներից մինչև կրեմային լասսի և ինդո-չինական նախընտրելիներ՝ ուսումնասիրեք բոլոր ուտեստները, որոնց համար հյուրերը նորից ու նորից գալիս են։',
    all: 'Բոլորը',
    add: 'Ավելացնել պատվերին',
    added: 'Ավելացված է',
    order: 'Ուղարկել պատվերը',
    request: 'Դիտել ձեր պատվերը',
    cats: {
      tea: 'Թեյ և Սուրճ',
      shakes: 'Լասսի, Շեյքեր և Հյութեր',
      snacks: 'Ամուլի ուտեստներ',
      chaat: 'Չաթ և Հնդկական ուտեստներ',
      starters: 'Չախնա և Ապետիզերներ',
      chinese: 'Չինական',
      raita: 'Ռայտա',
      pizza: 'Պիցցա / Պաստա',
      sweets: 'Քաղցրավենիք',
      mainVeg: 'Հիմնական կերակուր (բուս.)',
      nonVeg: 'Ոչ բուսական',
      rice: 'Բրինձ',
      breads: 'Հացեր',
      combo: 'Կոմբո / Հարավ-Հնդկական',
    },
    items: {
      'ginger-tea': {
        name: 'Ադրակ Թեյ',
        desc: 'Ջերմ համեմված թեյ՝ թարմ ադրակով, հիլով և կինամոնով՝ հնդկական դասական ըմպելիք։',
        tag: '',
      },
      'masala-tea': {
        name: 'Մասալա Թեյ',
        desc: 'Անուշահոտ սև թեյ՝ հիլով, մեխակով, կինամոնով, ադրակով և կաթով՝ Հնդկաստանի համը։',
        tag: 'Հանրաճանաչ',
      },
      'plain-tea': {
        name: 'Սովորական Թեյ',
        desc: 'Դասական հնդկական սև թեյ՝ կատարելությամբ պատրաստված, թեթև և թարմացնող։',
        tag: '',
      },
      'elaichi-tea': {
        name: 'Ելachi Թեյ',
        desc: 'Նուրբ սև թեյ՝ բուրավետ կանաչ հիլի պտուղներով, բնական քաղցր և անուշահոտ։',
        tag: '',
      },
      'lemon-tea': {
        name: 'Կիտրոն Թեյ',
        desc: 'Թարմացնող սև թեյ՝ թարմ կիտրոնի պայծառ քամվածքով՝ թթու, հանգստացնող և զորացնող։',
        tag: '',
      },
      'black-tea': {
        name: 'Սև Թեյ',
        desc: 'Ուժեղ և հարուստ հնդկական սև թեյ՝ մուգ պղնձագույնի՝ համարձակ և էներգիա տվող։',
        tag: '',
      },
      'green-tea': {
        name: 'Կանաչ Թեյ',
        desc: 'Թեթև և բուրավետ կանաչ թեյ՝ մաքուր խոտային նոտայով և մեղմ քաղցրությամբ։',
        tag: '',
      },
      'black-coffee': {
        name: 'Սև Սուրճ',
        desc: 'Հարուստ հարավհնդկական ֆիլտրային սուրճ՝ մուգ, համարձակ և լիքը՝ հարթ ավարտով։',
        tag: '',
      },
      'milk-coffee': {
        name: 'Կաթնային Սուրճ',
        desc: 'Հարթ և կրեմային հնդկական ոճի սուրճ՝ կաթով, մեղմ քաղցրացված և կատարյալ հավասարակշռված։',
        tag: '',
      },
      'cold-coffee': {
        name: 'Սառը Սուրճ',
        desc: 'Սառը սուրճ՝ կաթով և քաղցրության մեղմ շոշափումով, կրեմային, թարմացնող և էներգիա տվող։',
        tag: '',
      },
      'sweet-lassi': {
        name: 'Քաղցր Լասսի',
        desc: 'Հաստ և կրեմային քաղցրացված յոգուրտ ըմպելիք՝ վարդի մեղմ շոշափումով՝ պունջաբի դասական։',
        tag: 'Հանրաճանաչ',
      },
      'dry-fruit-lassi': {
        name: 'Չոր Մրգի Լասսի',
        desc: 'Հարուստ լասսի՝ նուշով, պիստակով, կաթնասերկով և շաֆրանով՝ շքեղ, ընկուզեղենով հյուրասիրություն։',
        tag: '',
      },
      'salt-lassi': {
        name: 'Աղի Լասսի',
        desc: 'Համեղ յոգուրտ ըմպելիք՝ տապակած քիմիոնով և աղի մեղմ շոշափումով՝ զովացնող և կատարյալ թթու։',
        tag: '',
      },
      'pudina-lassi': {
        name: 'Պուդինա Լասսի',
        desc: 'Թարմացնող յոգուրտ ըմպելիք՝ թարմ անանուխի տերևներով՝ զով, բուրավետ և զորացնող։',
        tag: '',
      },
      'banana-milkshake': {
        name: 'Բանանի Շեյք',
        desc: 'Կրեմային բանանի շեյք՝ կաթով և վանիլի մեղմ նոտայով՝ հաստ և բնական քաղցր։',
        tag: '',
      },
      'oreo-shake': {
        name: 'Օրեո Շեյք',
        desc: 'Հաճույք տվող շեյք՝ Օրեո թխվածքի փշուրներով, կրեմային վանիլային պաղպաղակով և շոկոլադե հեղուկով։',
        tag: '',
      },
      'chocolate-milkshake': {
        name: 'Շոկոլադե Շեյք',
        desc: 'Հարուստ շոկոլադե շեյք՝ իրական կակաոյով, թավշյա հարթ և շոկոլադե շavingsով։',
        tag: '',
      },
      'strawberry-milkshake': {
        name: 'Ելակի Շեյք',
        desc: 'Քաղցր ելակի շեյք՝ թարմ հատապտուղներով, կրեմային և բնական վարդագույն, թարմացնող։',
        tag: '',
      },
      'vanilla-milkshake': {
        name: 'Վանիլի Շեյք',
        desc: 'Դասական վանիլի շեյք՝ հաստ, կրեմային և հարթ՝ բոլոր տարիքների անժամանցելի նախընտրելի։',
        tag: '',
      },
      'mango-milkshake': {
        name: 'Մանգոյի Շեյք',
        desc: 'Արևադարձային մանգոյի շեյք՝ հասուն Ալֆոնսո մանգոյի միջուկով՝ հարուստ, ոսկեգույն և անընդհատ քաղցր։',
        tag: 'Հանրաճանաչ',
      },
      'dry-fruit-milkshake': {
        name: 'Չոր Մրգի Շեյք',
        desc: 'Ընկուզեղենային շեյք՝ նուշով, կաթնասերկով և ֆինիկով՝ առողջարար, սպիտակուցով հարուստ հյուրասիրություն։',
        tag: '',
      },
      'watermelon-juice': {
        name: 'Ձմրախոսի Հյութ',
        desc: 'Սեղմված ձմրախոսի թարմ հյութ՝ զով և բնական քաղցր՝ մաքուր ամառ մի բաժակի մեջ։',
        tag: '',
      },
      'orange-juice': {
        name: 'Նարնջի Հյութ',
        desc: 'Արևի լույսը բաժակում՝ սեղմված նարնջի հյութ, պայծառ, թթու և C վիտամինով լի։',
        tag: '',
      },
      'fresh-lime': {
        name: 'Թարմ Լայմ',
        desc: 'Կիզիչ թարմ լայմ ըմպելիք՝ քաղցր և թթու՝ փրփրուն պղպջականով՝ կատարյալ ծարավ մարող։',
        tag: '',
      },
      'blue-ocean-mojito': {
        name: 'Կապույտ Օվկիանոս Մոխիտո',
        desc: 'Հմայիչ կապույտ մոխիտո՝ անանուխով, կիտրոնով և արևադարձային կապույտ քուրասաոյի մեղմ շոշափումով՝ պայծառ և թարմացնող։',
        tag: '',
      },
      'virgin-mojito': {
        name: 'Վիրջին Մոխիտո',
        desc: 'Դասական ալկոհոլային մոխիտո՝ թարմ անանուխով, կիտրոնով և սոդայով՝ զով, անանուխոտ և զորացնող։',
        tag: '',
      },
      'lemon-mint': {
        name: 'Կիտրոն Անանուխ',
        desc: 'Զով կիտրոն ըմպելիք՝ թարմ անանուխի տերևներով՝ թթու, բուրավետ և անհավանական թարմացնող։',
        tag: '',
      },
      'veg-samosa': {
        name: 'Բանջարեղեն Սամոսա',
        desc: 'Խրթխրթան ոսկեգույն խմոր՝ համեմունքով կարտոֆիլով և սիսեռով լցված, մատուցվում է թթու մրգոտան պատիճով։',
        tag: '',
      },
      'paneer-samosa': {
        name: 'Պանիր Սամոսա',
        desc: 'Շերտավոր սամոսա՝ կրեմային պանիրով, խոտաբույսերով և կանաչ կծու պղպեղով լցված՝ հարուստ և բավարարող։',
        tag: '',
      },
      'veg-sandwich': {
        name: 'Բանջարեղեն Սենդվիչ',
        desc: 'Խորոված բանջարեղեն սենդվիչ՝ վարունգով, լոլիկով, սոխով և անանուխի պատիճով՝ թարմ և թեթև։',
        tag: '',
      },
      'grilled-cheese-sandwich': {
        name: 'Խորոված Պանիր Սենդվիչ',
        desc: 'Յուղոտ խորոված սենդվիչ՝ հալած պանիրով լցված, ոսկեգույն և յուզվող ամեն կծումով։',
        tag: '',
      },
      'omelette-sandwich': {
        name: 'Օմլետ Սենդվիչ',
        desc: 'Փափուկ օմլետ՝ խորոված հացի շերտերի միջև՝ թարմ բանջարեղենով և համեմունքի մեղմ շոշափումով։',
        tag: '',
      },
      'chicken-tikka-sandwich': {
        name: 'Հավ Թիկկա Սենդվիչ',
        desc: 'Թանդուրի հավ թիկկա՝ խորոված բուլկու մեջ՝ անանուխի մայոնեզով և խրթխրթան սոխով՝ ծխեցված և համարձակ։',
        tag: '',
      },
      'vada-pav': {
        name: 'Վադա Պավ',
        desc: 'Մումբայի ոճի համեմունքով կարտոֆիլե բլին՝ փափուկ բուլկու մեջ՝ սխտորի պատիճով և տապակած կանաչ կծու պղպեղով։',
        tag: 'Փողոցային',
      },
      'pav-bhaji': {
        name: 'Պավ Բհաջի',
        desc: 'Մումբայի հանրաճանաչ յուղոտ բանջարեղեն մածուկ՝ խորոված պավ բուլկիներով և յուղի գնդիկով։',
        tag: 'Լավագույն վաճառք',
      },
      'mirchi-vada': {
        name: 'Միրճի Վադա',
        desc: 'Կանաչ կծու պղպեղ՝ համեմունքով կարտոֆիլով լցված, խմորում թրծված և ոսկեգույն խրթխրթան։',
        tag: 'Կծու',
      },
      'mix-veg-pakora': {
        name: 'Խառը Բանջարեղեն Պակորա',
        desc: 'Տեսականի բանջարեղեն բլիններ՝ սոխ, կարտոֆիլ, կաղամբ և սպանախ՝ խմորապատ և խորը տապակած։',
        tag: '',
      },
      'paneer-pakora': {
        name: 'Պանիր Պակորա',
        desc: 'Թարմ պանիրի խորանարդներ՝ համեմունքով նութի ալյուրի խմորում՝ ոսկեգույն տապակած և պատիճով մատուցված։',
        tag: '',
      },
      'bread-pakora': {
        name: 'Հաց Պակորա',
        desc: 'Հացի կտորներ՝ համեմունքով խմորում թրծված և խորը տապակած՝ կարտոֆիլով լցված՝ թեյի ժամի նախընտրելի։',
        tag: '',
      },
      'egg-pakora': {
        name: 'Ձու Պակորա',
        desc: 'Կոշտ եփած ձու՝ համեմունքով խմորում փաթաթված և ոսկեգույն խրթխրթան՝ պարզ և բավարարող։',
        tag: '',
      },
      'bread-egg-omelette': {
        name: 'Հաց Ձվե Օմլետ',
        desc: 'Փափուկ ձվե օմլետ՝ խորոված հացի շերտերի միջև՝ առատ, բավարարող ամուլի ուտեստ։',
        tag: '',
      },
      'omelette-2egg': {
        name: 'Օմլետ [2 ձու]',
        desc: 'Դասական երկու ձվե օմլետ՝ սոխով, կանաչ կծու պղպեղով և կինդրով՝ տաք և փափուկ մատուցված։',
        tag: '',
      },
      'dahi-bhalla': {
        name: 'Դհի Բհալլա',
        desc: 'Փափուկ ոսպի գնդիկներ՝ քաղցր յոգուրտում թրծված, թթու մրգոտանի և կանաչ պատիճով։',
        tag: '',
      },
      'bhalla-papdi-chaat': {
        name: 'Բհալլա Պապդի Չաթ',
        desc: 'Բեռնված չաթ՝ բհալլայով, խրթխրթան պապդիով, յոգուրտով, պատիճներով և սիսեռով՝ քաղցր, թթու և կծու։',
        tag: '',
      },
      'dahi-puri': {
        name: 'Դհի Պուրի',
        desc: 'Խրթխրթան պարզ պուրիներ՝ կարտոֆիլով, սիսեռով, քաղցր յոգուրտով և պատիճներով լցված՝ համի պայթյուն։',
        tag: '',
      },
      'pani-puri': {
        name: 'Պանի Պուրի',
        desc: 'Չաթի արքան՝ խրթխրթան պուրիներ՝ կծու թթու ջրով, կարտոֆիլով և սիսեռով լցված։',
        tag: 'Հանրաճանաչ',
      },
      'papdi-chaat': {
        name: 'Պապդի Չաթ',
        desc: 'Խրթխրթան ալյուրե կծտորներ՝ եփած կարտոֆիլով, սիսեռով, յոգուրտով և մրգոտանի պատիճով։',
        tag: '',
      },
      'aloo-tikki-chaat': {
        name: 'Ալու Թիկկի Չաթ',
        desc: 'Ոսկեգույն կարտոֆիլե կրկնակներ՝ սիսեռով, յոգուրտով, պատիճներով և խրթխրթան սևով՝ խրթխրթան և կրեմային։',
        tag: '',
      },
      'tikki-chana-chaat': {
        name: 'Թիկկի Չանա Չաթ',
        desc: 'Խրթխրթան ալու թիկկի՝ համեմունքով սիսեռե կարու և պատիճներով՝ առատ, բավարարող չաթ։',
        tag: '',
      },
      'samosa-chana-chaat': {
        name: 'Սամոսա Չանա Չաթ',
        desc: 'Խրթխրթան սամոսա՝ համեմունքով սիսեռե կարու, յոգուրտով և պատիճներով՝ չաթի գլուխգործոց։',
        tag: '',
      },
      'aloo-paratha': {
        name: 'Ալու Պարատա',
        desc: 'Ամբողջ ցորենի պարատա՝ համեմունքով կարտոֆիլե մածուկով լցված, մատուցվում է յուղով և յոգուրտով։',
        tag: '',
      },
      'paneer-paratha': {
        name: 'Պանիր Պարատա',
        desc: 'Շերտավոր պարատա՝ փշրված պանիրով, կանաչ կծու պղպեղով և կինդրով լցված՝ հարուստ և բավարարող։',
        tag: '',
      },
      'mix-paratha': {
        name: 'Խառը Պարատա',
        desc: 'Լցված պարատա՝ համեմունքով բանջարեղենների խառնուրդով՝ առատ, առողջարար և համով լի։',
        tag: '',
      },
      'poori-bhaji': {
        name: 'Պուրի Բհաջի',
        desc: 'Փափուկ խորը տապակած պուրիներ՝ համեմունքով կարտոֆիլե կարու մատուցված՝ սիրված հնդկական նախաճաշի դասական։',
        tag: '',
      },
      'chhole-bhature': {
        name: 'Չհոլե Բհատուրա',
        desc: 'Պունջաբի հանրաճանաչ փափուկ բհատուրաներ՝ կծու սիսեռե կարու մատուցված՝ հարուստ, առատ և անմոռանալի։',
        tag: 'Պունջաբի դասական',
      },
      'lemon-chicken-pakora': {
        name: 'Կիտրոն Հավ Պակորա',
        desc: 'Խրթխրթան հավի բլիններ՝ պայծառ կիտրոնի զեթի պտուտքով, մատուցվում է անանուխի պատիճով։',
        tag: '',
      },
      'chicken-pakora': {
        name: 'Հավ Պակորա',
        desc: 'Նուրբ հավի կտորներ՝ համեմունքով խմորում և ոսկեգույն տապակած՝ ներսում հյութալի, դրսում խրթխրթան։',
        tag: '',
      },
      'paneer-tikka': {
        name: 'Պանիր Թիկկա',
        desc: 'Մարինացված պանիրի խորանարդներ՝ կծու պղպեղով և սոխով թանդուրում խորոված՝ ծխեցված և կրեմային։',
        tag: 'Շեֆի ընտրություն',
      },
      'brunt-chilli-paneer': {
        name: 'Այրած Կծու Պանիր',
        desc: 'Հրդեհավոր պանիր՝ կանաչ կծու պղպեղով, սոխով և սոյայի սոուսով՝ ինդո-չինական իր լավագույններից։',
        tag: '',
      },
      'brunt-chilli-chicken': {
        name: 'Այրած Կծու Հավ',
        desc: 'Կծու հավի կտորներ՝ այրած պղպեղով, սխտորով և սոյայով՝ համարձակ, ծխեցված և կախարդական։',
        tag: '',
      },
      'paneer-65': {
        name: 'Պանիր 65',
        desc: 'Խորը տապակած պանիրի խորանարդներ՝ կծու, թթու 65 ոճի սոուսում՝ կարիպար տերևներով և պղպեղով։',
        tag: '',
      },
      'chicken-65': {
        name: 'Հավ 65',
        desc: 'Առասպելային հարավհնդկական ստարտեր՝ կծու կարմիր 65 մասալայով խրթխրթան հավ՝ կարիպար տերևներով։',
        tag: 'Հանրաճանաչ',
      },
      'chilli-mushroom': {
        name: 'Կծու Սնկով',
        desc: 'Խրթխրթան տապակած սնկեր՝ կծու կծու սոուսում՝ կծու պղպեղով և սոխով՝ թթու և կծու։',
        tag: '',
      },
      'plain-papad': {
        name: 'Պարզ Պապադ',
        desc: 'Խրթխրթան տապակած ոսպե վաֆրեր՝ մեղմ համեմունքավորված՝ կատարյալ խրթխրթան ստարտեր յուրաքանչյուր կերակուրի հետ։',
        tag: '',
      },
      'masala-papad': {
        name: 'Մասալա Պապադ',
        desc: 'Խրթխրթան պապադ՝ կտրտած սոխով, լոլիկով, կանաչ կծու պղպեղով և կինդրով վերևում՝ թարմ և զեթ։',
        tag: '',
      },
      'peanut-masala': {
        name: 'Գետնանուշ Մասալա',
        desc: 'Տապակած գետնանուշ՝ սոխով, լոլիկով, կիտրոնի հյութով և համեմունքներով՝ խրթխրթան, թթու բար հյուրասիրություն։',
        tag: '',
      },
      'fried-masala-chana': {
        name: 'Տապակած Մասալա Չանա',
        desc: 'Խրթխրթան տապակած սիսեռ՝ չաթ մասալայով և համեմունքներով՝ կախարդական և խրթխրթան։',
        tag: '',
      },
      'cucumber-salad': {
        name: 'Վարունգ Աղցան',
        desc: 'Զով և խրթխրթան վարունգի կտորներ՝ կիտրոնով, չաթ մասալայով և թարմ կինդրով՝ թարմացնող։',
        tag: '',
      },
      'mix-green-salad': {
        name: 'Խառը Կանաչ Աղցան',
        desc: 'Պայծառ խառնուրդ՝ կանաչի, վարունգ, լոլիկ և սոխ՝ թեթև կիտրոնի սոուսով՝ թեթև և թարմ։',
        tag: '',
      },
      'onion-salad': {
        name: 'Սոխ Աղցան',
        desc: 'Բարակ կտրտած սոխի օղակներ՝ կանաչ կծու պղպեղով, կիտրոնով և չաթ մասալայով՝ սուր և թթու։',
        tag: '',
      },
      'fruit-chaat': {
        name: 'Մրգային Չաթ',
        desc: 'Թարմ սեզոնային մրգեր՝ չաթ մասալայով, սև աղով և կիտրոնի հյութով՝ քաղցր, թթու և կծու։',
        tag: '',
      },
      'french-fries': {
        name: 'Ֆրանսիական Ֆրի',
        desc: 'Ոսկեգույն, խրթխրթան ֆրանսիական ֆրի՝ կատարյալ աղացված և տաք մատուցված՝ դասական ժամանակակից ուտեստ։',
        tag: '',
      },
      'chilli-potato': {
        name: 'Կծու Կարտոֆիլ',
        desc: 'Խրթխրթան կարտոֆիլե կտորներ՝ կծու կծու սոուսում՝ կծու պղպեղով և սոխով՝ տաք և խրթխրթան։',
        tag: '',
      },
      'honey-chilli-fries': {
        name: 'Մեղր Կծու Ֆրի',
        desc: 'Խրթխրթան ֆրի՝ քաղցր մեղրով և կծու կծու սոուսում՝ քունջութի սերմերով՝ քաղցրը հանդիպում է կծուն։',
        tag: '',
      },
      'honey-chilli-cauliflower': {
        name: 'Մեղր Կծու Կաղամբ',
        desc: 'Խրթխրթան կաղամբե ծաղիկներ՝ կպչուն մեղր-կծու ժելեում՝ խրթխրթան, քաղցր և կծու։',
        tag: '',
      },
      'aloo-tikki-burger': {
        name: 'Ալու Թիկկի Բուրգեր',
        desc: 'Խրթխրթան կարտոֆիլե թիկկի կտոր՝ փափուկ բուլկու մեջ՝ մայոնեզով և թարմ բանջարեղենով՝ դեզի ոճի դասականի վրա։',
        tag: '',
      },
      'cheese-burger': {
        name: 'Պանիր Բուրգեր',
        desc: 'Հյութալի կտոր՝ հալած պանիրով, թարմ կանաչի և լոլիկով՝ խորոված բուլկու մեջ՝ ժամանակից հանգստի ուտեստ։',
        tag: '',
      },
      'paneer-burger': {
        name: 'Պանիր Բուրգեր',
        desc: 'Խորոված պանիրե կտոր՝ կծու մայոնեզով և խրթխրթան բանջարեղենով՝ փափուկ բուլկու մեջ՝ բուսակերների նախընտրելի։',
        tag: '',
      },
      'chicken-burger': {
        name: 'Հավ Բուրգեր',
        desc: 'Խորոված հավե կտոր՝ թարմ կանաչի, լոլիկ և մայոնեզով՝ խորոված բուլկու մեջ՝ հյութալի և բավարարող։',
        tag: '',
      },
      'desi-fried-burger': {
        name: 'Դեզի Տապակած Բուրգեր',
        desc: 'Խրթխրթան տապակած կտոր՝ հնդկական համեմունքներով լցված՝ սոխով և պատիճով՝ դեզի ոճի բուլկու մեջ։',
        tag: '',
      },
      'veg-maggi': {
        name: 'Բանջարեղեն Մագգի',
        desc: 'Դասական Մագգի լապշա՝ թարմ բանջարեղենով և դեզի համեմունքներով շաղված՝ արագ, կծու և նոստալգիկ։',
        tag: '',
      },
      'egg-maggi': {
        name: 'Ձու Մագգի',
        desc: 'Մագգի լապշա՝ թրթռված ձվով և բանջարեղենով՝ սպիտակուցով լցված մանկության նախընտրելիի վրա։',
        tag: '',
      },
      'masala-maggi': {
        name: 'Մասալա Մագգի',
        desc: 'Մագգի լապշա՝ ավելի շատ մասալայով, սոխով, լոլիկով և կանաչ կծու պղպեղով՝ համարձակ և դեզի։',
        tag: '',
      },
      'momos': {
        name: 'Մոմոս',
        desc: 'Գոլորշիով եփված գնդիկներ՝ համեմունքով բանջարեղենով կամ հավով լցված, մատուցվում է կծու կարմիր պատիճով։',
        tag: 'Հանրաճանաչ',
      },
      'veg-manchurian': {
        name: 'Բանջարեղեն Մանչուրիա',
        desc: 'Խրթխրթան բանջարեղեն գնդիկներ՝ թթու, կծու մանչուրիա սոուսում՝ սխտորով և գարնանային սոխով։',
        tag: '',
      },
      'chicken-manchurian': {
        name: 'Հավ Մանչուրիա',
        desc: 'Տապակած հավ՝ հարուստ, կծու մանչուրիա սոուսում՝ կծու պղպեղով և սոխով՝ դեզի-չինական դասական։',
        tag: '',
      },
      'hakka-noodles': {
        name: 'Հաքա Լապշա',
        desc: 'Շոգընթաց լապշա՝ խրթխրթան բանջարեղենով, սոյայի սոուսով և դեզի համեմունքներով՝ վոկ-շաղված կատարելություն։',
        tag: '',
      },
      'chicken-noodles': {
        name: 'Հավ Լապշա',
        desc: 'Վոկ-շաղված լապշա՝ նուրբ հավի կտորներով, բանջարեղենով և ծխեցված սոյա-կծու ժելեով։',
        tag: '',
      },
      'indian-chowmin': {
        name: 'Հնդկական Չաումին',
        desc: 'Դեզի ոճի չաումին՝ բանջարեղենով, ձվով և կծու սոուսներով՝ փողոցային ոճի լապշա իր լավագույններից։',
        tag: '',
      },
      'veg-spring-rolls': {
        name: 'Բանջարեղեն Գարնանային Ռուլետներ',
        desc: 'Ոսկեգույն խրթխրթան ռուլետներ՝ համեմունքով բանջարեղենով լցված, մատուցվում է քաղցր կծու թաթիկի սոուսով։',
        tag: '',
      },
      'tomato-soup': {
        name: 'Լոլիկի Ապուր',
        desc: 'Կրեմային լոլիկի ապուր՝ հնդկական համեմունքների մեղմ շոշափումով, տաք մատուցված՝ խրթխրթան կրուտոններով վերևում։',
        tag: '',
      },
      'chicken-manchow-soup': {
        name: 'Հավ Մանչոու Ապուր',
        desc: 'Առատ ինդո-չինական ապուր՝ կտրտած հավով, խրթխրթան լապշայով և համարձակ, կծու արգանակով։',
        tag: '',
      },
      'manchow-soup': {
        name: 'Մանչոու Ապուր',
        desc: 'Կծու բանջարեղեն մանչոու ապուր՝ խրթխրթան տապակած լապշայով վերևում՝ համարձակ, ջերմացնող և համով լի։',
        tag: '',
      },
      'hot-n-sour-soup': {
        name: 'Տաք և Քաղցր Ապուր',
        desc: 'Հրդեհավոր, թթու ապուր՝ բանջարեղենով, տոֆուով և սև պղպեղի և քացախի հարվածով՝ ինտենսիվ և բավարարող։',
        tag: '',
      },
      'plain-curd': {
        name: 'Պարզ Մածուն',
        desc: 'Թարմ տնական մածուն՝ զով և կրեմային՝ կատարյալ համի մաքրող ցանկացած կծու կերակուրի հետ։',
        tag: '',
      },
      'plain-raita': {
        name: 'Պարզ Ռայթա',
        desc: 'Զով կրեմային յոգուրտ՝ մեղմ համեմունքով։',
        tag: '',
      },
      'boondi-raita': {
        name: 'Բոոնդի Ռայթա',
        desc: 'Խրթխրթան բոոնդի յոգուրտի մեջ։',
        tag: '',
      },
      'mix-raita': {
        name: 'Խառը Ռայթա',
        desc: 'Բեռնված ռայթա՝ վարունգով, լոլիկով, սոխով։',
        tag: '',
      },
      'margarita-pizza': {
        name: 'Մարգարիտա Պիցցա',
        desc: 'Դասական պիցցա՝ լոլիկի սոուսով ու մոձցարելլայով։',
        tag: '',
      },
      'chef-veggie-pizza': {
        name: 'Շեֆի Բանջ. Պիցցա',
        desc: 'Կլոր պիցցա՝ գունավոր բանջ., սնկ., եգիպ., ձիթ., 3 պանիր։',
        tag: '',
      },
      'paneer-tikka-pizza': {
        name: 'Պանիր Թիկկա Պիցցա',
        desc: 'Թանդուրի պանիր, սոխ և կծու պղ. կաթլ. վրա։',
        tag: '',
      },
      'chicken-tikka-pizza': {
        name: 'Հավ Թիկկա Պիցցա',
        desc: 'Ծխ. հավ թիկկ. կաթ. վ. — Ինդո-իտ. ֆյուժն։',
        tag: '',
      },
      'onion-pizza': {
        name: 'Սոխ Պիցցա',
        desc: 'Կարամ. սոխ, մոձ. ու խոտ. բազ. կկ. վ.։',
        tag: '',
      },
      'boondi-laddu': {
        name: 'Բոոնդի Լադդու',
        desc: 'Ոսկ. կլ. կոնֆ. շաք. շ. մ.։',
        tag: '',
      },
      'khowa-barfi': {
        name: 'ԽոWa Բaрфи',
        desc: 'Հ. կ. բ. — հ. կ. կ.։',
        tag: '',
      },
      'kaju-katli': {
        name: 'Կալու Կաթլի',
        desc: 'Հ. կ. ադ. ակ. ու արծ. թ.։',
        tag: '',
      },
      'besan-barfi': {
        name: 'Բեsan Բaрфи',
        desc: 'Ն. ալ. բ. ղ. ռ. կ.։',
        tag: '',
      },
      'guliya': {
        name: 'Գուpiyа',
        desc: 'Կ. ն. ու kok. լ. կ.',
        tag: '',
      },
      'motichur-laddu': {
        name: 'Մ. Laddu',
        desc: 'Մ. ոsk. boondi lk.',
        tag: '',
      },
      'milk-cake': {
        name: 'Կ. Milk Cake',
        desc: 'Կ. կ. կ. կ.',
        tag: '',
      },
      'jalebi': {
        name: 'Ջaleby',
        desc: 'Խ. շաք. sp.',
        tag: '',
      },
      'gulab-jamun': {
        name: 'Gulab Jamun',
        desc: 'Փ. կ. sh. s.',
        tag: '',
      },
      'rasgula': {
        name: 'Rasgula',
        desc: 'Փ. sp. c. b. lsh. s.',
        tag: '',
      },
      'boondi-sweet': {
        name: 'Boondi',
        desc: 'Մ. ոsk. d. p.',
        tag: '',
      },
      'peda': {
        name: 'Peda',
        desc: 'Կ. m. f.',
        tag: '',
      },
      'rasmalai': {
        name: 'Ռasmalai',
        desc: 'Փ. p. s. s-i. m.',
        tag: '',
      },
      'daal-tadka': {
        name: 'Daal Tadka',
        desc: 'Ս. ո. լ. tk.',
        tag: '',
      },
      'aloo-matter': {
        name: 'Ало Матер',
        desc: 'Կ. կ. կ. p.',
        tag: '',
      },
      'aloo-chhole': {
        name: 'Ало Чhoле',
        desc: 'Кrd. к. с. p.',
        tag: '',
      },
      'zeera-aloo': {
        name: 'Зeera Aloo',
        desc: 'Кrd. c. с. cr.',
        tag: '',
      },
      'mix-veg-kolapuri': {
        name: 'Миксep Բ. Kolapuri',
        desc: 'Кrd. к. к. Ko.',
        tag: '',
      },
      'matter-paneer': {
        name: 'Matter Paneer',
        desc: 'Paneer ու ka.',
        tag: '',
      },
      'kadhai-paneer': {
        name: 'Kadhai Paneer',
        desc: 'Paneer ու caps.',
        tag: '',
      },
      'shahi-paneer': {
        name: 'Shahi Paneer',
        desc: 'Royal paneer gravy.',
        tag: '',
      },
      'paneer-lawabdar': {
        name: 'Paneer Lawabdar',
        desc: 'Paneer luscious gravy.',
        tag: '',
      },
      'adarki-daniya-paneer': {
        name: 'Adarki Daniya Paneer',
        desc: 'Ginger-coriander paneer.',
        tag: '',
      },
      'mushroom-payaja': {
        name: 'Mushroom Payaja',
        desc: 'Mushrooms onion gravy.',
        tag: '',
      },
      'sev-bhaji': {
        name: 'Sev Bhaji',
        desc: 'Crispy sev tomato gravy.',
        tag: '',
      },
      'paneer-butter-masala': {
        name: 'Paneer Butter Masala',
        desc: 'Butter cream paneer gravy.',
        tag: '',
      },
      'makhni-paneer': {
        name: 'Makhni Paneer',
        desc: 'Silky makhani paneer.',
        tag: '',
      },
      'daal-makhni': {
        name: 'Daal Makhni',
        desc: 'Black lentils butter cream.',
        tag: '',
      },
      'chicken-rara-masala': {
        name: 'Chicken Rara Masala',
        desc: 'Minced chicken chunks gravy.',
        tag: '',
      },
      'kadhai-chicken': {
        name: 'Kadhai Chicken',
        desc: 'Chicken capsicum kadhai.',
        tag: '',
      },
      'butter-chicken': {
        name: 'Butter Chicken',
        desc: 'Silky butter tomato chicken.',
        tag: '',
      },
      'lemon-chicken-gravy': {
        name: 'Lemon Chicken Gravy',
        desc: 'Zesty lemon chicken.',
        tag: '',
      },
      'chicken-curry': {
        name: 'Chicken Curry',
        desc: 'Classic chicken curry.',
        tag: '',
      },
      'egg-curry': {
        name: 'Egg Curry',
        desc: 'Boiled eggs tomato gravy.',
        tag: '',
      },
      'egg-bhurji': {
        name: 'Egg Bhurji [2 Egg]',
        desc: 'Scrambled spiced eggs.',
        tag: '',
      },
      'steamed-rice': {
        name: 'Steamed Rice',
        desc: 'Fluffy basmati.',
        tag: '',
      },
      'pea-pulao': {
        name: 'Pea Pulao Rice',
        desc: 'Basmati peas pulao.',
        tag: '',
      },
      'zeera-rice': {
        name: 'Zeera Rice',
        desc: 'Cumin basmati rice.',
        tag: '',
      },
      'veg-fried-rice': {
        name: 'Veg Fried Rice',
        desc: 'Wok vegetables rice.',
        tag: '',
      },
      'egg-fried-rice': {
        name: 'Egg Fried Rice',
        desc: 'Scrambled egg rice.',
        tag: '',
      },
      'chicken-fried-rice': {
        name: 'Chicken Fried Rice',
        desc: 'Chicken wok rice.',
        tag: '',
      },
      'veg-biryani': {
        name: 'Veg Biryani',
        desc: 'Basmati vegetable biryani.',
        tag: '',
      },
      'chicken-biryani': {
        name: 'Chicken Biryani',
        desc: 'Marinated chicken biryani.',
        tag: '',
      },
      'egg-biryani': {
        name: 'Egg Biryani',
        desc: 'Egg spiced biryani.',
        tag: '',
      },
      'tawa-roti': {
        name: 'Tawa Roti',
        desc: 'Whole wheat griddle bread.',
        tag: '',
      },
      'tawa-butter-roti': {
        name: 'Tawa Butter Roti',
        desc: 'Buttered griddle roti.',
        tag: '',
      },
      'simple-paratha': {
        name: 'Simple Paratha',
        desc: 'Layered wheat paratha.',
        tag: '',
      },
      'tandoori-roti': {
        name: 'Tandoori Roti',
        desc: 'Smoky tandoor roti.',
        tag: '',
      },
      'tandoori-butter-roti': {
        name: 'Tandoori Butter Roti',
        desc: 'Buttered tandoor roti.',
        tag: '',
      },
      'plain-naan': {
        name: 'Plain Naan',
        desc: 'Soft leavened naan.',
        tag: '',
      },
      'butter-naan': {
        name: 'Butter Naan',
        desc: 'Buttery soft naan.',
        tag: '',
      },
      'garlic-naan': {
        name: 'Garlic Naan',
        desc: 'Garlic coriander naan.',
        tag: '',
      },
      'messi-roti': {
        name: 'Messi Roti',
        desc: 'Multi-layer flaky roti.',
        tag: '',
      },
      'lacha-paratha': {
        name: 'Lacha Paratha',
        desc: 'Spiral layers paratha.',
        tag: '',
      },
      'onion-kulcha': {
        name: 'Onion Kulcha',
        desc: 'Spiced onion kulcha.',
        tag: '',
      },
      'aloo-kulcha': {
        name: 'Aloo Kulcha',
        desc: 'Potato stuffed kulcha.',
        tag: '',
      },
      'paneer-kulcha': {
        name: 'Paneer Kulcha',
        desc: 'Paneer stuffed kulcha.',
        tag: '',
      },
      'mix-kulcha': {
        name: 'Mix Kulcha',
        desc: 'Mixed stuffed kulcha.',
        tag: '',
      },
      'daal-rice-combo': {
        name: 'Daal / Rice',
        desc: 'Lentil curry with rice.',
        tag: '',
      },
      'rajma-rice-combo': {
        name: 'Rajma / Rice',
        desc: 'Kidney bean curry rice.',
        tag: '',
      },
      'chhole-rice-combo': {
        name: 'Chhole / Rice',
        desc: 'Chickpea curry rice.',
        tag: '',
      },
      'kaddi-rice-combo': {
        name: 'Kaddi / Rice [Կիrакi]',
        desc: 'Yogurt curry rice.',
        tag: '',
      },
      'daal-churma-combo': {
        name: 'Daal / Churma [Մehfil]',
        desc: 'Rajasthani feast.',
        tag: '',
      },
      'uttapam-combo': {
        name: 'Uttapam / Sambar / Chutney',
        desc: 'South Indian rice pancake.',
        tag: '',
      },
      'dosa-combo': {
        name: 'Dosa / Sambar / Chutney',
        desc: 'Crispy dosa with sambar.',
        tag: '',
      },
      'masala-dosa-combo': {
        name: 'Masala Dosa / Sambar / Chutney',
        desc: 'Potato stuffed dosa.',
        tag: '',
      },
      'vegy-burger-combo': {
        name: 'Veg Burger / Fries / Cola',
        desc: 'Complete quick meal.',
        tag: '',
      },
      'veg-paratha-fries-combo': {
        name: 'Veg Paratha + Fries',
        desc: 'Paratha with fries.',
        tag: '',
      },
      'paratha-roll-combo': {
        name: 'Paneer / Chicken Paratha Roll',
        desc: 'Stuffed paratha roll.',
        tag: '',
      },
      'veg-sandwich-club': {
        name: 'Veg Sandwich Club [Mehfil]',
        desc: 'Triple-decker veg club.',
        tag: '',
      },
      'chicken-sandwich-club': {
        name: 'Chicken Sandwich Club [Mehfil]',
        desc: 'Triple-decker chicken club.',
        tag: '',
      },
    },
  },
  gallery: {
    eyebrow: 'Պատկերասրահ',
    title: 'Պահեր սեղանի շուրջ',
    subtitle: 'Մտեք մեր ջերմ ինտերիերը, կրակի թանդուր խոհանոց և պայծառ չաթ սեղան։',
    t: {
      g1: 'Ջերմ և հյուրընկալ ինտերիեր',
      g2: 'Բաց կրակի թանդուր խոհանոց',
      g3: 'Պայծառ չաթ սեղան',
      g4: 'Թարմ համեմունքներ և խոտաբույսեր',
    },
  },
  hours: {
    eyebrow: 'Աշխատանքային ժամեր',
    title: 'Մեր դռները երբեք չեն փակվում',
    subtitle:
      'Ցերեկ թե գիշեր՝ Mehfil 24/7-ը այստեղ է։ Ուզեք նախաճաշ գիշերվա ժամը 3-ին, թե ուշ ընթրիք կեսգիշերին՝ մեր խոհանոցն ու տանիքը միշտ սպասում են ձեզ։',
    order: 'Պատվիրել հիմա',
    map: 'Գտնել մեզ քարտեզի վրա',
    schedule: 'Շաբաթական գրաֆիկ',
    open: 'Բաց է հիմա',
    open24: 'Բաց 24 ժամ',
    days: ['Երկուշաբթի', 'Երեքշաբթի', 'Չորեքշաբթի', 'Հինգշաբթի', 'Ուրբաթ', 'Շաբաթ', 'Կիրակի'],
  },
  reviews: {
    eyebrow: 'Կարծիքներ',
    title: 'Սիրված մեր հյուրերի կողմից',
    t: {
      t1text:
        'Մեհֆիլն իմ գիշերային վայրն է։ Պանիր թիկկան անկասկած լավագույնն է Երևանում, իսկ այն, որ բաց են 24/7՝ իսկական փրկություն է։',
      t2text:
        'Պավ բհաջի պատվիրեցի գիշերվա ժամը 2-ին, և այն հասավ տաք և կատարյալ փաթեթավորված։ Սամոսա չաթը համ ունի մումբայականի։',
      t3text:
        'Գեղեցիկ մթնոլորտ, ընկերասեր անձնակազմ և անհավանական մանգոյի շեյք։ Ինդո-չինական մենյուն այստեղ այն բանն է, որ չեք կարող գտնել Երևանի ուրիշ վայրերում։',
    },
  },
  booking: {
    eyebrow: 'Ամրագրումներ',
    title: 'Ամրագրել սեղան',
    subtitle:
      'Ամրագրեք ձեր տեղը և ուղարկեք ուղիղ մեր WhatsApp-ին. մենք անմիջապես կհաստատենք։',
    name: 'Ձեր անունը',
    phone: 'Հեռախոս',
    guests: 'Հյուրերի քանակ',
    date: 'Ամսաթիվ',
    time: 'Ժամ',
    note: 'Հատուկ խնդրանքներ (ըստ ցանկության)',
    send: 'Ուղարկել ամրագրումը WhatsApp-ով',
    sending: 'Բացվում է WhatsApp…',
  },
  order: {
    eyebrow: 'Տանել և առաքում',
    title: 'Ստեղծել պատվեր',
    subtitle:
      'Կազմեք ձեր պատվերը, ավելացրեք տվյալները և ուղարկեք ամեն ինչ մեր WhatsApp-ին։ Մենք արագ կհաստատենք և կառաքենք։',
    name: 'Ձեր անունը',
    phone: 'Հեռախոս',
    address: 'Առաքման հասցե',
    note: 'Պատվերի նշումներ (ըստ ցանկության)',
    send: 'Ուղարկել պատվերը WhatsApp-ով',
    sending: 'Բացվում է WhatsApp…',
    empty: 'Ձեր պատվերը դատարկ է. ավելացրեք ուտեստներ ստորև նշված մենյուից։',
    browse: 'Ծանոթանալ մենյուին',
    total: 'Ընդհանուր',
  },
  cart: {
    title: 'Ձեր պատվերը',
    empty: 'Ձեր պատվերը դատարկ է։ Ավելացրեք ուտեստներ մենյուից։',
    browse: 'Ծանոթանալ մենյուին',
    name: 'Ձեր անունը',
    phone: 'Հեռախոս',
    address: 'Առաքման հասցե',
    note: 'Նշումներ (ըստ ցանկության)',
    total: 'Ընդհանուր',
    send: 'Ուղարկել պատվերը WhatsApp-ով',
    clear: 'Մաքրել պատվերը',
    continue: 'Շարունակել դիտել',
    items: 'ուտեստ',
  },
  info: {
    visit: 'Այցելեք մեզ',
    call: 'Զանգահարեք 24/7',
    open: 'Միշտ բաց',
    delivery: 'Առաքում',
    address: 'Ռուբինյանց 28/1, Երևան 0069, Հայաստան',
    phone1: '+374 93 951149',
    phone2: '+374 93 951149',
    hours: 'Երկուշաբթի – Կիրակի, բաց 24 ժամ',
    deliv: 'Ամբողջ Երևանում, ~60 րոպե',
  },
  footer: {
    desc: 'Իսկական հնդկական խոհանոց՝ թանդուրից մինչև չաթ, մատուցվում է օրվա ցանկացած ժամի՝ Arman International LLC-ի կողմից։',
    links: 'Արագ հղումներ',
    touch: 'Կապ',
    follow: 'Հետևեք մեզ',
    about: 'Մեր մասին',
    menu: 'Մեր մենյուն',
    gallery: 'Պատկերասրահ',
    contact: 'Կապ',
    rights: 'Բոլոր իրավունքները պաշտպանված են։',
    tagline: 'Բաց ամեն օր, ամբողջ օրը։',
    curatedBy: 'Պատրաստել է',
  },
};